<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title text-uppercase">
          <h4>{{ $t('contra_voucher') }}</h4>
        </div>
      </div>
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link :to="{name:'ContraVoucher'}" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
        <li>
          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
        </li>
      </ul>
    </div>

    <div class="card table-list-card p-3 bg-white fs-7">
    <form @submit.prevent="submitBatch" enctype="multipart/form-data">
      <!-- Header Form Section -->
      <div class="row gy-2 gx-4 mb-3 justify-content-between align-items-center">
        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("voucher_no")}}</label>
          <input type="text" class="form-control" v-model="batches.voucher_no" readonly/>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("voucher_date")}}</label>
          <input type="date" class="form-control" v-model="batches.voucher_date" />
          <div v-if="errors.voucher_date" class="text-danger mt-2">
            <span>{{errors.voucher_date}}</span>
          </div>
        </div>

      </div>

      <!-- Item Input Section -->
      <div class="row g-2 mb-3 align-items-start fs-7">
        <div class="col">
          <div class="position-relative">
            <!-- Search Input -->
            <input
            type="text"
            v-model="debit_query"
            @input="debouncedDebitSearch"
            :placeholder="$t('search_item_by_name_code')"
            class="form-control"
            @keydown="handleKeys($event, 'debit')"
          />

            <!-- Dropdown Search Results -->
            <div
              v-if="debit_query"
              class="search-results shadow rounded bg-white position-absolute mt-2"
              style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
              :class="{ 'd-block': debitResults.length > 0, 'd-none': debitResults.length === 0 }"
            >

            <!-- Results List -->
            <ul class="list-group list-group-flush">
              <li
                v-for="(item, index) in debitResults"
                :key="item.id"
                class="list-group-item d-flex justify-content-between align-items-center"
                :class="{ 'bg-primary text-white': index === debitItemIndex }"
                style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
              >
                <!-- Clickable Product Info -->
                <div
                  class="flex-grow-1 d-flex flex-column"
                  @click="selectDebitItem(item)"
                  style="cursor: pointer;"
                >
                  <strong :class="index === debitItemIndex ? 'text-white' : 'text-dark'">
                    {{ item.node }} - {{ item.account_id }}
                  </strong>
                </div>
              </li>
            </ul>

            <!-- No Results -->
            <div v-if="!debitResults.length" class="text-center text-muted py-4" style="font-size: 1rem;">
              No results found
            </div>
          </div>
          </div>
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.debit_item">{{ errors.debit_item }}</span>
          </div>
        </div>



        <div class="col">
          <input type="number" class="form-control" placeholder="debit amount" v-model="batches.debit_amount" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.debit_amount">{{ errors.debit_amount }}</span>
          </div>
        </div>

        <div class="col">
          <div class="position-relative">
            <!-- Search Input -->
            <input
            type="text"
            v-model="credit_query"
            @input="debouncedCreditSearch"
            :placeholder="$t('search_item_by_name_code')"
            class="form-control"
            @keydown="handleKeys($event, 'credit')"
          />

            <!-- Dropdown Search Results -->
            <div
              v-if="credit_query"
              class="search-results shadow rounded bg-white position-absolute mt-2"
              style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
              :class="{ 'd-block': creditResults.length > 0, 'd-none': creditResults.length === 0 }"
            >

            <!-- Results List -->
            <ul class="list-group list-group-flush">
              <li
                v-for="(item, index) in creditResults"
                :key="item.id"
                class="list-group-item"
                :class="{ 'bg-primary text-white': index === creditItemIndex }"
                style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
                @click="selectCreditItem(item)"
              >
                <strong :class="index === creditItemIndex ? 'text-white' : 'text-dark'">
                  {{ item.node }} - {{ item.account_id }}
                </strong>
              </li>
            </ul>

            <!-- No Results -->
            <div v-if="!creditResults.length" class="text-center text-muted py-4" style="font-size: 1rem;">
              No results found
            </div>
          </div>
          </div>
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.credit_item">{{ errors.credit_item }}</span>
          </div>
        </div>

        

        <div class="col">
          <input type="number" class="form-control" placeholder="credit amount" v-model="batches.credit_amount" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.credit_amount">{{ errors.credit_amount }}</span>
          </div>
        </div>

        <div class="col">
          <input type="text" class="form-control" :placeholder="$t('narration')" v-model="batches.narration" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.narration">{{ errors.narration }}</span>
          </div>
        </div>

        



        <div class="col-auto">
          <button type="button" class="btn btn-info" @click="addItem">{{$t('add')}}</button>
        </div>
      </div>

      <!-- Items Table -->
      <div class="table-responsive mb-3 fixed-table">
        <table class="table table-bordered table-striped">
          <thead class="table-light">
            <tr>
              <th>{{ $t("debit_item") }}</th>
              <th>{{ $t("debit_amount") }}</th>
              <th>{{ $t("credit_item") }}</th>
              <th>{{ $t("credit_amount") }}</th>
              <th>{{ $t("narration") }}</th>
              <th>{{ $t("action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in addedItems" :key="index">
              <td>{{ item.debit_item_name }}</td>
              <td>{{ item.debit_amount }}</td>
              <td>{{ item.credit_item_name }}</td>
              <td>{{ item.credit_amount }}</td>
              <td>{{ item.narration }}</td>
              <td>
                <button type="button" class="btn btn-sm btn-danger" @click="removeItem(index)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row g-2 mt-4 align-items-start">
        <div class="col"></div>
        <div class="col">
          <label class="form-label small fw-semibold">{{ $t('total_debit') }}</label>
          <input type="text" class="form-control text-end bg-light" :value="totalAmount" disabled />
        </div>
        <div class="col"></div>
        <div class="col">
          <label class="form-label small fw-semibold">{{ $t('total_credit') }}</label>
          <input type="text" class="form-control text-end bg-light" :value="totalCreditAmount" disabled />
        </div>
        <div class="col"></div>
        <div class="col"></div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" :disabled="saving">{{ $t('submit') }}</button>
      </div>
    </form>
  </div>

  
</div>
</template>

<script>
import apiUrls from "@/urls";
import { useToast } from 'vue-toastification';
import debounce from 'lodash.debounce'
import { apiErrorMessage } from '@/helpers/apiError';
import { fetchCashBankHeads, searchVoucherHeads } from '@/helpers/voucherHeads';

const today = () => new Date().toISOString().split('T')[0];

export default {
  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      batches: {
        debit_item: null,
        credit_item: null,
        narration: '',
        debit_amount: '',
        credit_amount: '',
        voucher_no: '',
        voucher_date: today(),
      },
      transaction_category: null,
      errors: {},
      saving: false,

      debit_query: "",
      credit_query: "",

      debitResults: [],
      creditResults: [],
      debitItemIndex: 0,
      creditItemIndex: 0,
      selectedDebitItem: null,
      selectedCreditItem: null,
      addedItems: [],

      debouncedDebitSearch: null,
      debouncedCreditSearch: null,
      headsRequest: null,
    };
  },

  mounted() {
    this.fetchVoucherNo();
    this.fetchTransactionCategory();
  },

  computed: {
    totalAmount() {
      return this.addedItems.reduce((sum, item) => {
        return sum + (parseFloat(item.debit_amount) || 0);
      }, 0).toFixed(2);
    },
    totalCreditAmount() {
      return this.addedItems.reduce((sum, item) => {
        return sum + (parseFloat(item.credit_amount) || 0);
      }, 0).toFixed(2);
    }
  },

  methods: {
      async fetchVoucherNo() {
        try {
          const res = await this.$axios.get(apiUrls.journal_voucher_number.get, {
            params: { voucher_date: this.batches.voucher_date }
          });
          this.batches.voucher_no = res.data.voucher_no || '';
        } catch (err) {
          console.error(err);
        }
      },

      async fetchTransactionCategory() {
        try {
          const res = await this.$axios.get(apiUrls.transaction_category.get);
          // Not chosen on this form; the voucher records the shop's default category.
          this.transaction_category = res.data?.[0]?.id || null;
        } catch (err) {
          console.error(err);
        }
      },

      loadCashBankHeads() {
        if (!this.headsRequest) {
          this.headsRequest = fetchCashBankHeads(this.$axios).catch((error) => {
            this.headsRequest = null;
            throw error;
          });
        }
        return this.headsRequest;
      },

      async searchDebitItems() {
        if (!this.debit_query) {
          this.debitResults = []
          return
        }

        try {
          this.debitResults = searchVoucherHeads(await this.loadCashBankHeads(), this.debit_query);
          this.debitItemIndex = 0;
        } catch (error) {
          console.error('Search error:', error)
          this.debitResults = []
        }
      },

      async searchCreditItems() {
        if (!this.credit_query) {
          this.creditResults = []
          return
        }

        try {
          this.creditResults = searchVoucherHeads(await this.loadCashBankHeads(), this.credit_query);
          this.creditItemIndex = 0;
        } catch (error) {
          console.error('Search error:', error)
          this.creditResults = []
        }
      },

      selectDebitItem(item) {
        this.selectedDebitItem = item
        this.debit_query = item.node
        this.batches.debit_item = item.account_id
        this.debitResults = []
        this.debitItemIndex = 0;
      },
      selectCreditItem(item) {
        this.selectedCreditItem = item
        this.credit_query = item.node
        this.batches.credit_item = item.account_id
        this.creditResults = []
        this.creditItemIndex = 0;
      },

      handleKeys(event, type) {
        const results = type === 'credit' ? this.creditResults : this.debitResults;
        const indexKey = type === 'credit' ? 'creditItemIndex' : 'debitItemIndex';

        if (event.key === 'ArrowDown') {
          this[indexKey] = Math.min(this[indexKey] + 1, results.length - 1);
          event.preventDefault();
        } else if (event.key === 'ArrowUp') {
          this[indexKey] = Math.max(this[indexKey] - 1, 0);
          event.preventDefault();
        } else if (event.key === 'Enter') {
          const selectedProduct = results[this[indexKey]];
          if (selectedProduct) {
            if (type === 'credit') {
              this.selectCreditItem(selectedProduct);
            } else {
              this.selectDebitItem(selectedProduct);
            }
          }
          event.preventDefault();
        }
      },

      addItem() {
        this.errors = {};

        if (!this.selectedDebitItem) {
          this.errors.debit_item = this.$t('error.required');
        }

        if (!this.selectedCreditItem) {
          this.errors.credit_item = this.$t('error.required');
        } else if (
          this.selectedDebitItem &&
          String(this.selectedDebitItem.account_id) === String(this.selectedCreditItem.account_id)
        ) {
          this.errors.credit_item = 'Choose a different account from the debit side.';
        }

        ["debit_amount", "credit_amount"].forEach(field => {
          if (!(parseFloat(this.batches[field]) > 0)) this.errors[field] = this.$t('error.required');
        });
        if (!this.batches.voucher_date) this.errors.voucher_date = this.$t('error.required');

        if (Object.keys(this.errors).length > 0) {
          return;
        }

        this.addedItems.push({
          ...this.batches,
          debit_item_name: this.selectedDebitItem.node,
          debit_item_code: this.selectedDebitItem.account_id,
          credit_item_name: this.selectedCreditItem.node,
          credit_item_code: this.selectedCreditItem.account_id,
        });
        this.clearRowFields();
      },

      async submitBatch() {
        if (this.saving) return;
        if (!this.addedItems.length) {
          this.toast.warning("Please add at least one contra row before submitting.");
          return;
        }

        if (parseFloat(this.totalAmount) !== parseFloat(this.totalCreditAmount)) {
          this.toast.warning("Debit and credit totals must be equal.");
          return;
        }

        // Each grid row is one debit line and one credit line of the same voucher.
        const common = {
          flag: 'ct',
          transaction_category: this.transaction_category,
          voucher_no: this.batches.voucher_no,
          voucher_date: this.batches.voucher_date,
        };
        const batches = this.addedItems.flatMap((row) => [
          { ...common, item: row.debit_item_code, type: 'debit', amount: row.debit_amount, narration: row.narration },
          { ...common, item: row.credit_item_code, type: 'credit', amount: row.credit_amount, narration: row.narration },
        ]);

        this.saving = true;
        try {
          await this.$axios.post(apiUrls.journal_voucher_create.post, { batches });

          this.toast.success("Contra voucher submitted successfully!");
          this.addedItems = [];
          this.$router.push({ name: 'ContraVoucher' });
        } catch (error) {
          this.toast.error(apiErrorMessage(error));
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors;
          }
        } finally {
          this.saving = false;
        }
      },

      cancelForm() {
        this.$router.push({ name: 'ContraVoucher' });
      },

      removeItem(index) {
        this.addedItems.splice(index, 1);
      },

      clearRowFields() {
        this.batches = {
          debit_item: null,
          credit_item: null,
          narration: '',
          debit_amount: '',
          credit_amount: '',
          voucher_no: this.batches.voucher_no,
          voucher_date: this.batches.voucher_date,
        };
        this.debit_query = '';
        this.credit_query = '';
        this.debitResults = [];
        this.creditResults = [];
        this.debitItemIndex = 0;
        this.creditItemIndex = 0;
        this.selectedDebitItem = null;
        this.selectedCreditItem = null;
        this.errors = {};
      },
    },

  watch: {
    'batches.voucher_date'(newDate) {
      if (newDate) {
        this.fetchVoucherNo();
      } else {
        this.batches.voucher_no = '';
      }
    },
  },

  created() {
    this.debouncedDebitSearch = debounce(this.searchDebitItems, 300)
    this.debouncedCreditSearch = debounce(this.searchCreditItems, 300)
  },
};
</script>


<style scoped>
/* Optional: adjust table and input heights */
.table td, .table th {
  vertical-align: middle;
}

.fixed-table {
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

/* Modal Backdrop */
.confirm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal Box */
.confirm-modal {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: fadeInScale 0.2s ease;
}

/* Header */
.confirm-header h4 {
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
}

/* Body Rows */
.confirm-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.confirm-row.due {
  color: #dc3545;
  font-weight: 600;
  font-size: 16px;
}

/* Buttons */
.confirm-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* Animation */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>
